module.exports = __webpack_public_path__ + "static/img/s2en.f818502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s2en.png
// module id = 9Bzb
// module chunks = 0